import $ from "jquery";

$(document).ready(function () {
  // Gets the video src from the data-src on each button
  let videoSrc;
  document.querySelectorAll(".video-btn").forEach((button) => {
    button.addEventListener("click", () => {
      // Get the video source from the data-src attribute
      videoSrc = button.dataset.src;
      console.log(videoSrc);
    });
  });
  let videoModal = document.getElementById("videoModal");
  let video = document.getElementById("video");
  // Add event listener for when the modal is opened
  videoModal.addEventListener("shown.bs.modal", () => {
    // Update the video source with autoplay and other options
    video.src = videoSrc + "?autoplay=1&amp;modestbranding=1&amp;showinfo=0";
  });

  // Add event listener for when the modal is closed
  videoModal.addEventListener("hide.bs.modal", () => {
    // Stop the video by resetting the source
    video.src = "";
  });

  // document ready
});
